import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-screen bg-secondary flex items-center justify-center px-6 pt-20"
      data-testid="not-found-page"
    >
      <div className="max-w-lg w-full bg-white border border-border rounded-lg p-10 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-accent mb-4">Erreur 404</p>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
          Page introuvable
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="inline-block btn-primary px-6 py-2 rounded"
          data-testid="not-found-home-link"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
